<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '放款明细表'}]"/>
    <el-row class="xzpadd10 bg-purple">
     <!-- -->

      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">贷款本金合计：{{(totalAmounts/10000).toFixed(2)||''}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">笔数合计：{{listData.count}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">贷款余额合计：{{(balanceAmounts/10000).toFixed(2)||''}}</div></el-col></div>
      </data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "FinancingPaymentList",
    data() {
      return {
        page: 1,
        pageSize: 20,
        listData: {},
        totalAmounts:0,
        balanceAmounts:0,
        listColumns: [
          {
            name: '序号',
            type: 'index'
          },

          {
            name: '流水号',
            field: 'pay__reference'
          },
            {
                name: '贷款编号',
                field: 'fi__transactionNo'
            },
          {
            name: '客户姓名',
            field: 'fi__customerName'
          },
          {
            name: '渠道商',
            field: 'd__dealerName'
          },
          {
            name: '贷款产品',
            field: 't__productName'
          },
          {
            name: '贷款本金',
            field: 'fi__totalAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '贷款合同利率（%）',
            field: 'fi__interestRate'
          },
          {
            name: '起息日',
            field: 'fi__startDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },

          {
            name: '到期日',
            field: 'fi__endDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },
          {
            name: '实际放款日',
            field: 'pay__payDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },

          {
            name: '贷款余额',
            field: 'fi__balanceAmount',
            formatter: function (r,c,v) {
                if(v)
              return formatMoney(v)
                else
                    return''
            }
          },
          {
            label: '状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
                if(v)
              return Status2CN('Financing_'+v)
                else
                    return''
            }
          },
          {
            name: '摘要',
            field: 'pay__txUse'
          },
        ],
        filters: {
          form: {
            pay__payDate: [],
            fi__customerName:'',
            d__dealerId:'',
            pay__reference:'',
          },
          columns: [
            {
              label: '流水号',
              component: 'el-input',
              field: 'pay__reference',
            },
            {
              label: '实际放款日',
              component: 'date-range-picker',
              field: 'pay__payDate',
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'fi__customerName',
            },
            {
              label: '渠道商',
              component: 'el-select',
              field: 'd__dealerId',
              options:[],
              span: 12
            },

          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          },
          onReset: ()=> {
            this.filters.form = {
              pay__payDate: [],
              fi__customerName:'',
              d__dealerName:'',
            }
            this.listData= {
              count: 0,
              data: []
            }
            this.totalAmounts = 0
            this.balanceAmounts = 0
          }
        },
        actions: [
          {
            label: '导出',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/fang/financing/reporting/FinancingPayment.List?format=xls',
                query: Object.assign({ pageSize:0,}, this.filterParams, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ],
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
           /* pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,*/
           /* 'xlist.sort.dataField': 'fi.transactionDate',
            'xlist.sort.order': 'desc'*/
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getData()
      }
    },
    mounted() {
      //this.getData()
      this.getDealerList()
    },
    methods: {
      getData: function () {
        xhr.getReportingFinancingPaymentList(
          Object.assign({
            pageSize:0,
          }, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.totalAmounts= 0
              this.balanceAmounts = 0
              this.listData = res.data
              this.listData.data.forEach(item=>{
                if(item.fi__totalAmount){
                  this.totalAmounts = this.totalAmounts +parseFloat(item.fi__totalAmount)*10000
                }
                if(item.fi__balanceAmount){
                  this.balanceAmounts = this.balanceAmounts +parseFloat(item.fi__balanceAmount)*10000
                }
              })

                this.listData.data.push({
                    pay__reference:'合计',
                    fi__totalAmount:(this.totalAmounts/10000).toFixed(2)||'',
                    fi__balanceAmount:(this.balanceAmounts/10000).toFixed(2)||''
                })
            }catch(e){

            }
          })

      },
      getDealerList: function () {
        xhr.getDealerList(
          Object.assign({pageSize:0}, {}, {}),
          res=> {
            try {
           /*   this.filters.columns[3].options = [
                {
                  label: '所有渠道商',
                  value: ''
                }
              ].concat(res.data.data.map(item=>{
                return {
                  label: item.d__dealerName,
                  value:item.d__dealerId,
                }
              }))*/
              this.filters.columns[3].options = res.data.data.map(item=>{
                return {
                  label: item.d__dealerName,
                  value:item.d__dealerId,
                }
              })
            }catch(e){

            }
          })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FinancingPaymentList.vue